<template>
<div class="mapWidth">
    <div id="worldmap-wrapper-container">
      <v-flex xs12 d-flex class="mt-20">
        <p class="body-2 mt-8 mr-7">
          For <span class="font-weight-medium">building regulatory information by location</span>,
          select a country from map.
        </p>
      </v-flex>
      <v-overlay :value="mapLoader">
        <v-progress-circular color='white' indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div id='worldmap' ref="worldMapSvg" style="margin: 0 auto; padding-bottom: 47.25%; z-index: 1"></div>
      <div id='antarcticaMap' ref="antarctica" style="margin-top: -41%; margin-bottom: -7%; z-index: 0"></div>
    </div>
    <global-code-footer></global-code-footer>
</div>
</template>
<script>
import CONSTANTS from '../../../config/constant'
import GlobalCodeFooter from '../footercontent/GlobalCodeFooter'
import * as Datamap from 'datamaps'
import d3 from 'd3'
let scale = 100
let clipExtent = [[100, 454], [960, 554]]
let marginTop = '-41%'
let paddingBottom = '56.25%'
if (window.matchMedia('(max-width: 320px)').matches) {
  scale = 20
  clipExtent = [[50, 100], [960, 554]]
  paddingBottom = '54.25%'
  marginTop = '-41%'
}
if (window.matchMedia('(min-width: 321px) and (max-width: 360px)').matches) {
  scale = 20
  clipExtent = [[50, 104], [960, 554]]
  paddingBottom = '54.25%'
  marginTop = '-41%'
}
if (window.matchMedia('(min-width: 361px) and (max-width: 480px)').matches) {
  scale = 25
  clipExtent = [[50, 124], [960, 554]]
  paddingBottom = '57.25%'
  marginTop = '-41%'
}
if (window.matchMedia('(min-width: 481px) and (max-width: 768px)').matches) {
  scale = 30
  clipExtent = [[50, 190], [960, 554]]
  paddingBottom = '51.25%'
  marginTop = '-40%'
}
if (window.matchMedia('(min-width: 769px) and (max-width: 812px)').matches) {
  scale = 30
  clipExtent = [[50, 230], [960, 554]]
  paddingBottom = '47.25%'
  marginTop = '-38%'
}
if (window.matchMedia('(min-width: 813px) and (max-width: 1024px)').matches) {
  scale = 60
  clipExtent = [[50, 340], [960, 594]]
  paddingBottom = '52.25%'
  marginTop = '-40%'
}
if (window.matchMedia('(min-width: 1025px) and (max-width: 1200px)').matches) {
  scale = 100
  clipExtent = [[50, 230], [960, 554]]
  paddingBottom = '47.25%'
  marginTop = '-38%'
}
if (window.matchMedia('(min-width: 1201px) and (max-width: 1366px)').matches) {
  scale = 100
  clipExtent = [[100, 454], [960, 554]]
  paddingBottom = '56.25%'
  marginTop = '-41%'
}
if (window.matchMedia('(min-width: 1367px)').matches) {
  scale = 100
  clipExtent = [[50, 450], [960, 554]]
  paddingBottom = '56.25%'
  marginTop = '-41%'
}
export default {
  name: 'worldMap',
  components: {
    'global-code-footer': GlobalCodeFooter
  },
  data: () => ({
    mapLoader: false,
    countryName: '',
    countryAbbr: ''
  }),
  mounted () {
    this.drawMap()
    this.$globalFromValidation.forceTabActive(this.$route.name)
  },
  methods: {
    /**
     * // Map related functions
    */
    drawMap () {
      const container = this.$refs.worldMapSvg
      const antarcticaContainer = this.$refs.antarctica
      container.innerHTML = ''
      /* eslint-disable no-unused-vars */
      const datamap = new Datamap({
        element: container,
        scope: 'world',
        geographyConfig: {
          hideAntarctica: true,
          popupTemplate: (geo) => {
            this.countryAbbr = geo.id
            this.countryName = geo.properties.name
            this.countryName = this.countryName.split(' ').join('-').toLowerCase()
            return '<div class="hoverinfo">' + geo.properties.name + '</div>'
          },
          popupOnHover: true, // True to show the popup while hovering
          highlightOnHover: true,
          highlightFillColor: '#FFA201',
          isAbbreviation: false,
          highlightBorderColor: '#FFFFFF'
        },
        responsive: true,
        fills: {
          defaultFill: 'rgb(235, 241, 244)'
        },
        data: {},
        done: datamap => {
          datamap.svg.selectAll('.datamaps-subunit').on('click', geography => {
            this.mapLoader = true
            const formData = {
              code: geography.id,
              isAbbreviation: false,
              codeLevel: CONSTANTS.COUNTRY_LEVEL,
              parentCode: '',
              parentLevel: CONSTANTS.ABBR_PARENT_LEVEL
            }
            if (this.countryAbbr === CONSTANTS.DEFAULT_COUNTRY_NAME) {
              this.$router.push({ name: 'Home', params: { pageId: true } })
            } else {
              this.$router.push({ name: 'WorldCodeAdoption', params: { countryName: this.countryName, locateMe: true } })
            }
          })

          window.addEventListener('resize', function () {
            datamap.resize()
          })
        }
      })

      const datamapATA = new Datamap({
        element: antarcticaContainer,
        scope: 'world',
        geographyConfig: {
          hideAntarctica: false,
          popupTemplate: (geo) => {
            this.countryAbbr = geo.id
            this.countryName = geo.properties.name
            this.countryName = this.countryName.split(' ').join('-').toLowerCase()
            return '<div class="hoverinfo">' + geo.properties.name + '</div>'
          },
          popupOnHover: true, // True to show the popup while hovering
          highlightOnHover: true,
          highlightFillColor: '#FFA201',
          isAbbreviation: false,
          highlightBorderColor: '#FFFFFF'
        },
        setProjection: function (element) {
          var projection = d3.geo.mercator()
            .center([0, 0])
            .rotate([4.4, 0])
            .scale(scale)
            .translate([element.offsetWidth / 2, element.offsetHeight / 2])
            .clipExtent(clipExtent)
            // .clipExtent([[left, top], [right, bottom]]) this for the future reference
          var path = d3.geo.path()
            .projection(projection)

          return { path: path, projection: projection }
        },
        responsive: true,
        fills: {
          defaultFill: 'rgb(235, 241, 244)'
        },
        data: {},
        done: datamap => {
          datamap.svg.selectAll('.datamaps-subunit').on('click', geography => {
            this.mapLoader = true
            const formData = {
              code: geography.id,
              isAbbreviation: false,
              codeLevel: CONSTANTS.COUNTRY_LEVEL,
              parentCode: '',
              parentLevel: CONSTANTS.ABBR_PARENT_LEVEL
            }
            if (this.countryAbbr === CONSTANTS.DEFAULT_COUNTRY_NAME) {
              this.$router.push({ name: 'Home', params: { pageId: true } })
            } else {
              this.$router.push({ name: 'WorldCodeAdoption', params: { countryName: this.countryName, locateMe: true } })
            }
          })
          const worldmap = document.getElementById('worldmap')
          const antarcticaMap = document.getElementById('antarcticaMap')
          worldmap.style.paddingBottom = '47.50%'

          antarcticaMap.style.marginTop = marginTop
          antarcticaMap.style.paddingBottom = paddingBottom
          window.addEventListener('resize', function () {
            datamap.resize()
          })
        }
      })
    }
  }
}
</script>
